module.exports = __webpack_public_path__ + "img/icon-generic-generic7.267bae08.svg";